<div class="filters-section">
<div ds-loading-area-container>
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-md-3">
        <ds-form-field>
          <label ds-label for="brandSelect" class="form-label">Vehicle Model</label>
          <ds-select
            id="brandSelect"
            [labellingConfig]="{ placeholder: 'Select a Model' }"
            [options]="modelSelectList"
            [(ngModel)]="filters.impmodel"
            (optionSelected)="onModelChange($event)"
            required
            [showClearAll]="true"
            [disabled]="isModelDisabled"
          ></ds-select>
        </ds-form-field>
      </div>

      <div class="col-md-3">
        <ds-form-field>
          <label ds-label for="version1" class="form-label">Vehicle Group</label>
          <ds-select
            id="version1"
            [labellingConfig]="{ placeholder: 'Select a Group' }"
            [options]="groupsSelectList"
            [(ngModel)]="filters.impmodel_group"
            (optionSelected)="onVehicleGroupChange($event)"
            [showClearAll]="true"
            [disabled]="isGroupDisabled"
          ></ds-select>
        </ds-form-field>
      </div>
      <div class="col-md-3">
        <ds-form-field>
          <label ds-label for="exterior1" class="form-label">Exterior</label>
          <ds-select
            id="exterior1"
            [labellingConfig]="{ placeholder: 'Select a Exterior' }"
            [options]="filteredExteriorOptions"
            [(ngModel)]="filters.impmodel_colour"
            (optionSelected)="onExteriorSelect($event)"
            [showClearAll]="true"
            [disabled]="isOtherSelectsDisabled"
          ></ds-select>
        </ds-form-field>
      </div>
      <div class="col-md-3">
        <ds-form-field>
          <label ds-label for="interior1" class="form-label">Interior</label>
          <ds-select
            id="interior1"
            [labellingConfig]="{ placeholder: 'Select a Interior' }"
            [options]="filteredInteriorOptions"
            [(ngModel)]="filters.impmodel_trim"
            (optionSelected)="onInteriorSelect($event)"
            [showClearAll]="true"
            [disabled]="isOtherSelectsDisabled"
          ></ds-select>
        </ds-form-field>
      </div>
    </div>
  </div>
  <br />

  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-md-3">
        <ds-form-field>
          <label ds-label for="option1" class="form-label">Option 1</label
          >
          <ds-select
            id="option1"
            [labellingConfig]="{ placeholder: 'Select Option' }"
            [options]="filteredModelOptions"
            [(ngModel)]="filters.impmodel_inopt1"
            [showClearAll]="true"
            [disabled]="isOtherSelectsDisabled"
            (optionSelected)="onIncludeOptionOneChange($event)"
          ></ds-select>
        </ds-form-field>
      </div>
      <div class="col-md-3">
        <ds-form-field>
          <label ds-label for="option2" class="form-label">Option 2</label>
          <ds-select
            id="option2"
            [labellingConfig]="{ placeholder: 'Select Option' }"
            [options]="filteredModelOptions"
            [(ngModel)]="filters.impmodel_inopt2"
            [disabled]="isOtherSelectsDisabled"
            [showClearAll]="true"
            (optionSelected)="onIncludeOptionTwoChange($event)"
          ></ds-select>
        </ds-form-field>
      </div>
      <div class="col-md-3">
        <ds-form-field>
          <label ds-label for="option3" class="form-label">Option 3</label>
          <ds-select
            id="option3"
            [labellingConfig]="{ placeholder: 'Select Option' }"
            [options]="filteredModelOptions"
            [(ngModel)]="filters.impmodel_inopt3"
            [disabled]="isOtherSelectsDisabled"
            [showClearAll]="true"
            (optionSelected)="onIncludeOptionThreeChange($event)"
          ></ds-select>
        </ds-form-field>
      </div>
      <div class="col-md-3">
        <ds-form-field>
          <label ds-label for="excludeOption" class="form-label">Exclude Options</label>
          <ds-select
            id="excludeOption"
            [labellingConfig]="{ placeholder: 'Select Option to Exclude' }"
            [options]="filteredModelOptions"
            [(ngModel)]="filters.impmodel_exopt1"
            [disabled]="isOtherSelectsDisabled"
            [showClearAll]="true"
            (optionSelected)="onExcludeOptionOneChange($event)"
          ></ds-select>
        </ds-form-field>
      </div>
    </div>
  </div>
  <br>
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-md-3">
        <ds-form-field>
          <label ds-label for="orders" class="form-label">Orders</label
          >
          <ds-select
            id="orders"
            [labellingConfig]="{ placeholder: 'Select Orders' }"
           [options]="[{ label: 'All', id: 'all' }, { label: 'Conf', id: 'CHG_ONLY' }, { label: 'RFI', id: 'RFI_ONLY' }]"
            [(ngModel)]="filters.orders"
            [disabled]="isOtherSelectsDisabled"
            [showClearAll]="true"
            (change)="onFiltersChange()"
          ></ds-select>
        </ds-form-field>
      </div>
    </div>
  </div>
</div>
</div>

